import { defineMessages } from 'react-intl'

export default defineMessages({
  deal : {
    id: 'containers.HandoverPage.tableHead.deal',
    defaultMessage: 'Deal',
  },
  company : {
    id: 'containers.HandoverPage.tableHead.company',
    defaultMessage: 'Company',
  },
  priority : {
    id: 'containers.HandoverPage.tableHead.priority',
    defaultMessage: 'Priority',
  },
  deliveryDeadline : {
    id: 'containers.HandoverPage.tableHead.deliveryDeadline',
    defaultMessage: 'Delivery Deadline',
  },
  numberOfLanguages : {
    id: 'containers.HandoverPage.tableHead.numberOfLanguages',
    defaultMessage: '# of Languages',
  },
  numberOfVts : {
    id: 'containers.HandoverPage.tableHead.numberOfVts',
    defaultMessage: "# of VT's",
  },
  preferredLanguage : {
    id: 'containers.HandoverPage.tableHead.preferredLanguage',
    defaultMessage: 'Preferred Language',
  },
  complexOrder : {
    id: 'containers.HandoverPage.tableHead.complexOrder',
    defaultMessage: 'Complex Order',
  },
  currentlyAt : {
    id: 'containers.HandoverPage.tableHead.currentlyAt',
    defaultMessage: 'Currently at',
  },
  notSetDeadline: {
    id: 'containers.HandoverPage.notSetDeadline',
    defaultMessage: 'Not Set',
  },
  languageCountSpan: {
    id: 'containers.HandoverPage.languageCountSpan',
    defaultMessage: 'languages',
  },
  vtCountSpan: {
    id: 'containers.HandoverPage.vtCountSpan',
    defaultMessage: 'VTs',
  },
  complexYesSpan: {
    id: 'containers.HandoverPage.complexYesSpan',
    defaultMessage: 'Yes',
  },
  complexNoSpan: {
    id: 'containers.HandoverPage.complexNoSpan',
    defaultMessage: 'No',
  },
  currentlyAtAssignedSpan: {
    id: 'containers.HandoverPage.currentlyAtAssignedSpan',
    defaultMessage: 'Assigned',
  },
  currentlyAtNotAssignedSpan: {
    id: 'containers.HandoverPage.currentlyAtNotAssignedSpan',
    defaultMessage: 'Not assigned',
  },
  noHandoversAvailable: {
    id: 'containers.HandoverPage.noHandoversAvailable',
    defaultMessage: 'No handovers available at this stage.',
  }
})
